import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { QueryParamProvider } from 'use-query-params';
import AvailablePlots from './pages/AvailablePlots';
import DevelopmentListing from './pages/DevelopmentListing';
import SearchBox from './pages/SearchBox';

const App = () => {
  ReactDOM.render(
    <Router>
      <Switch>
        <Route path="/" exact><SearchBox /></Route>
          <QueryParamProvider ReactRouterRoute={Route}>
            <Route path="/find-your-home" exact><DevelopmentListing /></Route>
            <Route path="/find-your-home/:name"><AvailablePlots /></Route>
          </QueryParamProvider>
      </Switch>
    </Router>, document.getElementById('react-app'));
};

export default App;